import React from "react";
import { SuggestionHitProps } from "./types/HitProps";
import { useDispatch } from "react-redux";
import { setAlgoliaSearchQuery } from "../../../Actions/AlgoliaSearch.action";

const SuggestionHit = ({ hit }: SuggestionHitProps) => {
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(setAlgoliaSearchQuery(hit.query));
  };

  return hit.isPageLink ? (
    <a key={hit.url} className="algolia-suggestions__page-link" href={hit.url}>
      <span>{hit.label}</span>
      <span className="algolia-suggestions__page-link__icon">
        <i className="ph-arrow-right"></i>
      </span>
    </a>
  ) : (
    <a className="algolia-suggestions__item" onClick={onClick}>
      <span className="algolia-suggestions__item__icon">
        <i className="icon-search"></i>
      </span>
      <span>{hit.query}</span>
    </a>
  );
};

export default SuggestionHit;
